import getEnvironDomain from "ati-utils/getEnvironDomain";

export default () => {
  const domain = getEnvironDomain();

  return window?.location ? domain : "ati.su";
};
